var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.79 12.09a2.42 2.42 0 012.44-2.4h4.85V8H6.23A4.18 4.18 0 002 12.09a4.18 4.18 0 004.22 4.16h4.86V14.5H6.23a2.41 2.41 0 01-2.44-2.4zM17.77 8H13v1.69h4.81a2.41 2.41 0 11.32 4.81H13v1.75h4.81A4.18 4.18 0 0022 12.1 4.18 4.18 0 0017.78 8zM6.91 12.09a.91.91 0 00.91.89h8.39a.89.89 0 10.19-1.76H7.82a.91.91 0 00-.91.87z"
})));

export default SvgIconLink;